export default {
    STORE_TOOLS(state, data) {
        state.tools = data;
        console.log(state);
    },
}